import React, { useState } from 'react';
import { Button, Input, Modal } from 'antd';
import './InputPhone.scss';
import * as api from '../../services/api';
import OpenPhoneSuccess from './OpenPhoneSuccess';
import appId from '../../golbal';

const InputPhone = ({ visible, onClose, trailId, inviterId,state }: any) => {
  const [phone, setPhoneValue] = useState('');
  const [code, setCodeValue] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [showErr, setShowErr] = useState(false);
  const [errPhoneMsg, setErrPhoneMsg] = useState('');
  const [showCodeErr, setCodeShowErr] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [codeDisabled, setCodeDisabled] = useState(false);
  const [count, setCount] = useState(0);
  let timer: any = null;
  let countNum = 0;
  const handleSubmit = async () => {
    if (!phone.trim()) {
      setErrMsg('手机号必填');
      setShowErr(true);
      return;
    }
    if (!code.trim()) {
      setErrPhoneMsg('验证码必填');
      setCodeShowErr(true);
      return;
    }
    setDisabled(true);
    let result: any = await api.phoneRegister(
      '+86-' + phone.trim(),
      trailId,
      code,
      state,
      inviterId
    );
    if (result.error) {
      setDisabled(false);
      setErrMsg(result.error);
      setShowErr(true);
      return;
    }
    if (result.body) {
      setDisabled(false);
      onClose(true, result.body.days);
      return;
    }
  };
  const phoneValueChange = (value: any) => {
    setPhoneValue(value);
    if (value) {
      setShowErr(false);
    }
  };
  const codeValueChange = (value: any) => {
    setCodeValue(value);
    if (value) {
      setCodeShowErr(false);
    }
  };
  const getCode = async () => {
    if (!phone.trim()) {
      setErrMsg('手机号必填');
      setShowErr(true);
      return;
    }
    let phoneReg = /^[1]([3-9])[0-9]{9}$/;
    if (!phone.match(phoneReg)) {
      setErrMsg('手机号格式不正确');
      setShowErr(true);
      return;
    }
    //@ts-ignore
    let captcha = new TencentCaptcha(appId, async function(res: any) {
      if (res.ret === 0) {
        // let resData = await userService.phoneCode({
        //   accountName:'+86-'+value.accountName,
        //   ticket: res.ticket,
        //   randstr: res.randstr,
        // });
        // if (resData) {
        //   setCodeLoading(true)
        //   setCodeResData(resData)
        // }
        setCodeDisabled(true);
        let result: any = await api.getPhoneCode(
          '+86-' + phone.trim(), trailId,res.ticket,res.randstr,state
        );
        if (result.error) {
          setCodeDisabled(false);
          setErrPhoneMsg(result.error);
          setCodeShowErr(true);
          return;
        }
        if (result.body) {
          setErrPhoneMsg('');
          setCodeShowErr(false);
          await setCount(result.body.interval);
          countNum = result.body.interval;
          timer = await setInterval(() => {
            if (countNum === 0) {
              setCodeDisabled(false);
              clearInterval(timer);
            } else {
              setCount(countNum - 1);
              countNum--;
            }
          }, 1000);
          return;
        }
      }
    });
    await captcha.show();
  };
  return <Modal centered visible={visible} onCancel={onClose} closable={false} footer={null} width={270}>
    <div style={{ paddingBottom: 50, position: 'relative' }}>
      <div style={{ fontSize: 17, fontWeight: 500, textAlign: 'center', marginBottom: 20 }}>填写手机号</div>
      <div style={{ position: 'relative', marginBottom: 20 }}>
        <Input onChange={e => phoneValueChange(e.target.value)} size={'large'} placeholder={'手机号'}/>
        {
          showErr ? <div style={{
            fontSize: 12,
            fontWeight: 500,
            color: 'rgb(251, 76, 58)',
            position: 'absolute',
            bottom: '-17px'
          }}>{errMsg}</div> : null
        }
      </div>
      <div style={{ position: 'relative' }}>
        <Input onChange={e => codeValueChange(e.target.value)} style={{ background: '#F0F0F0' }}
               addonAfter={<button disabled={codeDisabled} style={{
                 border: '0',
                 background: 'none',
                 color: 'rgb(251, 76, 58)',
                 outline: 'none'
               }}
                                   onClick={() => {
                                     getCode();
                                   }}>{count ? count + 's' : '获取验证码'}</button>} size={'large'} placeholder={'验证码'}/>
        {
          showCodeErr ? <div style={{
            fontSize: 12,
            fontWeight: 500,
            color: 'rgb(251, 76, 58)',
            position: 'absolute',
            bottom: '-17px'
          }}>{errPhoneMsg}</div> : null
        }
      </div>
    </div>
    <div className={'islide-modal-footer'}>
      <Button onClick={onClose}>取消</Button>
      <Button style={{ color: '#FB4C3A' }} disabled={disabled} onClick={() => handleSubmit()}>确定</Button>
    </div>
  </Modal>;
};

export default InputPhone;
